<template>
  <div class="empty">
    <div class="integral">
      <div class="intCenter">
        <img src="/static/images/successful@2x.png" />
        <p>
          您的资料已提交成功<br />
          审核结果会在1-3个工作日内下发
        </p>
        <!--        <button class="redbtn" @click="go">去看看</button>-->
      </div>
    </div>
    <div class="footer footerIOS">
      <button class="submit" @click="go">返回社区</button>
    </div>
  </div>
</template>

<script>
import {
  isWeixin,
  fenxiang,
  isApp,
  exclusiveidFn,
  pointParams
} from '../../assets/common/js/config'
import wx from 'weixin-js-sdk'

export default {
  name: 'submitsuccessful',
  mounted: function() {
    if (isWeixin()) {
      fenxiang({ path: 'submitsuccessful' })
    }
  },
  methods: {
    go() {
      var arg = isApp()
      if (arg == '') {
        this.$router.replace('/community')
      } else if (arg.indexOf('xcx') >= 0) {
        wx.miniProgram.reLaunch({
          url:
            '/pages/communityindex/main?exclusiveid=' +
            exclusiveidFn() +
            pointParams('&')
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.empty {
  height: 100%;
}
.integral {
  height: calc(100vh - 0.73rem);
  background: #fff;
  position: relative;
  .intCenter {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    img {
      width: 1.12rem;
      height: 1.12rem;
      margin: 0 auto;
    }
    p {
      font-size: 0.17rem;
      font-weight: normal;
      color: #444444;
      line-height: 0.18rem;
      margin-top: 0.23rem;
      margin-bottom: 0.96rem;
      text-align: center;
      white-space: nowrap;
      &.go {
        color: #fc0324;
        position: relative;
        top: -0.9rem;
        text-align: center;
        line-height: 0.14rem;
        .van-icon,
        .van-icon::before {
          vertical-align: bottom;
        }
        &.noDatades {
          top: -0.8rem;
        }
      }
    }
    .redbtn {
      outline: none;
      margin: 0 auto;
      display: block;
      background: none;
      min-width: 1.09rem;
      border-radius: 0.2rem;
      padding: 0.08rem 0;
      border: 1px solid rgba(252, 3, 36, 1);
      font-size: 0.14rem;
      font-weight: 400;
      color: rgba(252, 3, 36, 1);
      line-height: 0.2rem;
    }
  }
}

.footer {
  display: flex;
  align-items: center;
  padding: 0.1rem 0.11rem;
  background: #ffffff;
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 2;
  .submit {
    flex: 1;
    display: block;
    margin-bottom: 0.1rem;
    line-height: 0.43rem;
    background: linear-gradient(90deg, #fc0324 0%, #f63a66 100%);
    border: none;
    outline: none;
    color: #fff;
    font-size: 0.17rem;
    border-radius: 0.25rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/emptypage/submitsuccessful.vue